import type { Role } from '@gcv/shared';
import { GcdAccountOwnershipRole, GcdUserRole, PayqwickUserRole } from '@gcv/shared';

export const DispensaryRoleOptions: { value: Role; label: string }[] = [
  { value: 'dispensary_account_owner', label: 'Account Owner' },
  { value: 'dispensary_admin', label: 'Admin' },
  { value: 'dispensary_deposit_recorder', label: 'Deposit Recorder' },
  { value: 'dispensary_deposit_transport', label: 'Deposit Transport' },
  { value: 'dispensary_questionnaire_completer', label: 'Questionnaire Completer' },
  { value: 'dispensary_user', label: 'User' }
  // If updating this array, please add in alphabetical order by label
];

export const BankRoleOptions: { value: Role; label: string }[] = [
  { value: 'bank_account_internal_editor', label: 'Account Administrator' },
  { value: 'bank_account_facilitator', label: 'Account Facilitator' },
  { value: 'bank_primary_contact', label: 'Account Owner' },
  { value: 'bank_account_review_approver', label: 'Account Review Approver' },
  { value: 'bank_account_review_preparer', label: 'Account Review Preparer' },
  { value: 'bank_admin', label: 'Admin' },
  { value: 'bank_examiner', label: 'Auditor / Examiner' },
  { value: 'bank_sponsor', label: 'Banking Sponsor' },
  { value: 'bank_core_data_admin', label: 'Core Data Admin' },
  { value: 'bank_counterparty_editor', label: 'Counterparty Editor' },
  { value: 'bank_deposit_approver', label: 'Deposit Approver' },
  { value: 'bank_document_approver', label: 'Document Approver' },
  { value: 'bank_document_preparer', label: 'Document Preparer' },
  { value: 'bank_questionnaire_admin', label: 'Due Diligence / Questionnaire Admin' },
  { value: 'bank_due_diligence_template_editor', label: 'Due Diligence Template Editor' },
  { value: 'bank_edit_crb_info', label: 'Edit CRB Info' },
  { value: 'bank_fincen_approver', label: 'FinCEN Approver' },
  { value: 'bank_fincen_preparer', label: 'FinCEN Preparer' },
  { value: 'bank_kyc', label: 'KYB / KYC Admin' },
  { value: 'bank_marketplace_editor', label: 'Marketplace Manager' },
  { value: 'bank_negative_news_reviewer', label: 'Negative News Reviewer' },
  { value: 'bank_questionnaire_assigner', label: 'Questionnaire Assigner / Viewer' },
  { value: 'bank_questionnaire_template_editor', label: 'Questionnaire Template Editor' },
  { value: 'bank_user', label: 'Standard User' }
  // If updating this array, please add in alphabetical order by label
];

export const PayqwickRoleOptions: { value: PayqwickUserRole | 'none'; label: string }[] = [
  /** 'none' is not a valid value and needs to be excluded from API requests */
  { value: 'none', label: 'No Access' },
  { value: PayqwickUserRole.Admin, label: 'Admin' },
  { value: PayqwickUserRole.Employee, label: 'Employee' },
  { value: PayqwickUserRole.Manager, label: 'Manager' }
  // If updating this array, please add in alphabetical order by label with `No Access` first
];

export const GcdRoleOptions: { value: GcdUserRole | 'none'; label: string }[] = [
  /** 'none' is not a valid value and needs to be excluded from API requests */
  { value: 'none', label: 'No Access' },
  { value: GcdUserRole.Admin, label: 'Admin' },
  { value: GcdUserRole.Employee, label: 'Employee' },
  { value: GcdUserRole.Manager, label: 'Manager' }
  // If updating this array, please add in alphabetical order by label with `No Access` first
];

export const GcdOwnershipRoleOptions: { value: GcdAccountOwnershipRole | 'none'; label: string }[] = [
  /** 'none' is not a valid value and needs to be excluded from API requests */
  { value: 'none', label: 'No Access' },
  { value: GcdAccountOwnershipRole.OnlineBanking, label: GcdAccountOwnershipRole.OnlineBanking },
  { value: GcdAccountOwnershipRole.Owner, label: GcdAccountOwnershipRole.Owner },
  { value: GcdAccountOwnershipRole.Signer, label: GcdAccountOwnershipRole.Signer }
  // If updating this array, please add in alphabetical order by label with `No Access` first
];

export const ownershipRoleKey = '_ownershipRole';
